module.exports = __webpack_public_path__ + "static/img/invest-consume9.0ffadc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume9.jpg
// module id = edF1
// module chunks = 0